import { useEffect, useState } from "react";
import {useCommerceApi} from "@/context/CommerceScope";

export default function AuthenticatedApiImage({ path, alt = "", className = "", fallback = null }) {
  const api=useCommerceApi();
  const [src,setSrc]=useState("");
  useEffect(()=>{
    if(!path){setSrc("");return undefined;}
    let active=true; let objectUrl="";
    api.client.get(path.startsWith("/api/") ? path.slice(4) : path,{responseType:"blob"}).then((response)=>{
      if(!active)return;
      objectUrl=URL.createObjectURL(response.data);setSrc(objectUrl);
    }).catch(()=>{if(active)setSrc("");});
    return()=>{active=false;if(objectUrl)URL.revokeObjectURL(objectUrl);};
  },[path,api]);
  if(!src)return fallback;
  return <img src={src} alt={alt} className={className}/>;
}
